/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Dismiss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Dismiss"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M18.44 20.56a1.5 1.5 0 0 0 2.12-2.12L14.122 12l6.44-6.44a1.5 1.5 0 0 0-2.122-2.12L12 9.878l-6.44-6.44A1.5 1.5 0 1 0 3.44 5.56L9.878 12l-6.44 6.44a1.5 1.5 0 0 0 2.122 2.12L12 14.122z"
      className="SVG"
    />
  </svg>
);

export const DismissIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'dismiss-icon'}
      icon={Dismiss}
      {...props}
      size={size}
    />
  );
};
